import { getOrdinalSuffix } from 'utils';
export const getPeriodText = (min, max) => {
    if (min === 1 && max === 31) {
        return 'Any day of the month';
    }
    return `${min}${getOrdinalSuffix(min)} to ${max}${getOrdinalSuffix(max)} of the month`;
};
